var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 28,
    viewBox: "0 0 15 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66634 16.0001H12.9997L14.333 10.6667H9.66634V8.00008C9.66634 6.62675 9.66634 5.33342 12.333 5.33342H14.333V0.853415C13.8983 0.796082 12.257 0.666748 10.5237 0.666748C6.90367 0.666748 4.33301 2.87608 4.33301 6.93341V10.6667H0.333008V16.0001H4.33301V27.3334H9.66634V16.0001Z",
    fill: "#BBC6D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a4ffbf483f23b532d866be8978ff2f79.svg";
export { ForwardRef as ReactComponent };